import './App.css'
import { TableLayout } from './components/Table'
import { Footer } from './components/Footer'
import 'bootstrap/dist/css/bootstrap.min.css'

function App() {
  return (
    <div className='d-flex flex-column min-vh-100'>
      <TableLayout />
      <Footer />
    </div>
  )
}

export default App
